import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';

i18next
    .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        useSuspense: false,
        fallbackLng: 'fr', // use fr if detected lng is not available
        keySeparator: '.', // we do not use keys in form messages.welcome
        whitelist: ['fr', 'en'],
        defaultNS: 'translation',
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // nous indiquons tout simplement une URL complète
        },
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18next;
